module.exports = __webpack_public_path__ + "static/media/tf.44fa0da8.svg";